import styled from '@emotion/styled'

export const TabsContainer = styled.div`
  display: flex;
  overflow: hidden;
  padding: 0 10px;
`

export const TabItem = styled.div`
  flex: 1;
  padding: ${({variant}) => (variant === 'payment' ? '12px 18px' : '6px 12px')};
  font-size: 13px;
  cursor: pointer;
  border-bottom: ${({active, borderColor}) =>
    active ? `3px solid ${borderColor || '#FF5000'}` : 'none'};
  background: ${({active, activeBackground}) =>
    active
      ? activeBackground || 'linear-gradient(#DDE1EABF, #ffffff00)'
      : 'none'};

  &:last-child {
    border-right: none;
  }

  .amount {
    font-size: 20px;
    font-weight: 700;

    span {
      font-size: 13px;
    }

    &.blue {
      color: #5378fc;
    }
  }

  .label {
    font-size: 12px;
    color: #666666;
    font-weight: 700;

    span {
      font-weight: 400;
    }

    &.blue {
      color: #0070f3;
    }
  }
`
